import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getCases(params: any): AxiosPromise {
    return EndPointService.get('/occasions', { params });
}
function getCasesSmall(params: any): AxiosPromise {
    return EndPointService.get('/occasions-simply-list', { params });
}
function getCaseNumbers(params: any): AxiosPromise {
    return EndPointService.get('/case-number', { params });
}
function getCaseNumbersStudent(id: any): AxiosPromise {
    return EndPointService.get(`/case-number/student?id=${id}`);
}

function getCase(id: number | string): AxiosPromise {
    return EndPointService.get(`/occasions/${id}`);
}

function deleteCase(id: number | string): AxiosPromise {
    return EndPointService.delete(`/occasions/${id}`);
}

function getStatementDocs(params: any): AxiosPromise {
    return EndPointService.get('/statement_docs', { params });
}
function createStatementCase(payload: any): AxiosPromise {
    return EndPointService.put(`/occasions/statement/${payload.id}`, payload);
}
function createCase(payload: any): AxiosPromise {
    return EndPointService.post('/occasions', payload);
}

function deleteFileCase(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/occasion_docs/${fileId}`);
}

function createFilesCase(data: any): AxiosPromise {
    return EndPointService.post(`/occasion_docs`, data);
}

function getFilesCase(id: string | number): AxiosPromise {
    return EndPointService.get(`/occasion_docs`, {
        params: {
            'occasion.id': id,
        },
    });
}

function updateCase(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/occasions/${id}`, { ...payload });
}

export default {
    getCases,
    getCasesSmall,
    getStatementDocs,
    getFilesCase,
    getCaseNumbers,
    getCaseNumbersStudent,
    createFilesCase,
    createStatementCase,
    deleteFileCase,
    getCase,
    deleteCase,
    createCase,
    updateCase,
};
